import { Row } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';
import { LoadRecord } from '../../../types/load';

import { OutboundMaterialsEditor } from './OutboundMaterialsEditor';

type OutboundTicketTabMaterialsProps = {
  load: LoadRecord | null;
};

//
// ⚛️ ⚛️ ⚛️ OUTBOUND TICKET TAB MATERIALS ⚛️ ⚛️ ⚛️
//
export const OutboundTicketTabMaterials = ({
  load,
}: OutboundTicketTabMaterialsProps) => {
  const t = useTranslations();

  if (!load) {
    return (
      <Row xCenter yCenter className="h-full w-full text-foreground/50">
        {t.scaleTicketPro.noTicketData}
      </Row>
    );
  }

  return (
    <div className="@OutboundTicketTabMaterials h-full">
      <OutboundMaterialsEditor ticket={load} />
    </div>
  );
};
